type CalcValue = string | number;

function toCssValue(value: CalcValue): string {
  return typeof value === "number" ? `${value}px` : value;
}

export const calc = {
  add: (...values: CalcValue[]) =>
    `calc(${values.map((value) => toCssValue(value)).join(" + ")})`,
  subtract: (...values: CalcValue[]) =>
    `calc(${values.map((value) => toCssValue(value)).join(" - ")})`,
  multiply: (value: CalcValue, multiplier: number) =>
    `calc(${toCssValue(value)} * ${multiplier})`,
  divide: (value: CalcValue, divisor: number) =>
    `calc(${toCssValue(value)} / ${divisor})`
};
